import ModuleRoute from "components/ModuleRoute/ModuleRoute";
import PageRoute from "components/PageRoute/PageRoute";
import React from "react";
import { Navigate, RouteObject } from "react-router-dom";

const TeamManagementModule = React.lazy(() => import("./TeamManagementModule"));
const MembersPage = React.lazy(() => import("./pages/MembersPage/MembersPage"));
const TransactionsPage = React.lazy(() => import("./pages/TransactionsPage/TransactionsPage"));
const TeamQuestionTemplatesPage = React.lazy(
  () => import("./pages/TeamQuestionTemplatesPage/TeamQuestionTemplatesPage"),
);
const ClientSettingsPage = React.lazy(() => import("./pages/ClientSettingsPage/ClientSettingsPage"));

export const TeamManagementModuleRoutes: RouteObject = {
  path: ":clientId/manage-team/*",
  element: (
    <ModuleRoute El={TeamManagementModule} moduleName="team-management" inPolicy="SharedViewerTeamAdmin" />
  ),
  children: [
    {
      path: "overview",
      element: <Navigate to={"members"} />, // Overview pages was removed for teams; redirect to members
    },
    {
      path: "members/:tab?",
      element: <PageRoute El={MembersPage} />,
    },
    {
      path: "transactions/:tab?",
      element: <PageRoute El={TransactionsPage} />,
    },
    {
      path: "",
      element: <Navigate to={"members"} />,
    },
    {
      path: "templates",
      element: <PageRoute El={TeamQuestionTemplatesPage} />,
    },
    {
      path: "guidelines",
      element: <PageRoute El={ClientSettingsPage} ff="ProjectNarratives" />,
    },
  ],
};
